// extracted by mini-css-extract-plugin
module.exports = {"error":"_5D2BKQ-o","eyebrow":"_5D1zxIGp","formGroup":"_5D14SAHh","input__label":"_5D3fxYqM","loader":"_5D2MeQzk"};